import { createContext, useContext } from 'react';

export interface MFEMetadata {
    shadowRoot: ShadowRoot;
    portalShadowRoot: ShadowRoot;
}

export const MFEMetadataContext = createContext<MFEMetadata>({} as MFEMetadata);

export function useMFEMetadataContext() {
    const context = useContext(MFEMetadataContext);

    return context;
}
